/* eslint-disable no-underscore-dangle */ // allow dangling underscore in var name because we have no control over it

import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import reducer from 'redux/reducer';

let _store;
export default function getStore() {
  if (_store === undefined) {
    _store = createStore(reducer, composeWithDevTools(
      applyMiddleware(thunk),
    ));
  }

  return _store;
}



// WEBPACK FOOTER //
// ./src/redux/store.js